import {makeGet, makePost} from "../Functions";
import {FetchEvents, RequestGroup} from "../RequestGroup";
import {Product} from "../jtmc/models/Product";
import {MenuDetails} from "../jtmc/models/MenuDetails";
import {OrderType} from "../../types";
import Service from "../jtmc/models/Service";
import {Model} from "../jtmc/Model";
import Game from "../jtmc/models/Game";

export class Menu extends RequestGroup {
    branchId = 0;
    tableId = 0;
    orderType: OrderType = "table";

    constructor(props: { defaultEvents: any, branchId: number, orderType: OrderType, tableId: number }) {
        super({
            defaultEvents: props.defaultEvents
        });
        this.branchId = props.branchId;
        this.orderType = props.orderType;
        this.tableId = props.tableId;
    }

    requests = {
        getAllProducts: () => {
            return this.customPromise((events: FetchEvents) => {
                makeGet("/products/getAll",
                    {branch_id: this.branchId},
                    events,
                    true);
            }, {class: Product, isArray: true})
        },
        getMenuDetails: () => {
            return this.customPromise((events: FetchEvents) => {
                makeGet(`/menu/${this.branchId}/${this.orderType}/${this.tableId}`,
                    null,
                    events,
                    true);
            }, {class: MenuDetails, isArray: false})
        },
        requestService: (service: Service) => {
            return this.customPromise((events: FetchEvents) => {
                makePost(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/service`,
                    {},
                    {
                        service_id: service.id
                    },
                    events,
                    true);
            }, {class: Model, isArray: false})
        },
        waiterCall: () => {
            return this.customPromise((events: FetchEvents) => {
                makePost(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/waiter`,
                    {},
                    {},
                    events,
                    true);
            }, {class: Model, isArray: false})
        },
        getGames: () => {
            return this.customPromise((events: FetchEvents) => {
                makeGet(`/menu/${this.branchId}/${this.orderType}/${this.tableId}/games/get`,
                    null,
                    events,
                    true);
            }, {class: Game, isArray: true})
        },
    }
}